<div class="dialog">
        <div><mat-toolbar class="tool"><span>Confirmation</span></mat-toolbar></div>
        <div class="message">
            <span>Are you sure you want to delete the selected Unit.</span>
        </div>
        <div class="b-middle">
            <button class="deletebutton" (click)="remove()" mat-button>Delete</button><button (click)="closeDialog()" mat-button>Cancel</button>
        </div>   
    </div>